'use client'

import * as React from 'react'
import { IconChevronRight } from '@repo/design-system-cf/components/icons'
import { tw } from 'utils/classnames'

export function LinksContainer({
  children,
  className,
  testid,
}: React.PropsWithChildren<{ className?: string; testid?: string }>) {
  const scrollRef = React.useRef<HTMLDivElement>(null)
  const [hasOverflow, setHasOverflow] = React.useState(false)

  const checkOverflow = React.useCallback(() => {
    if (!scrollRef.current) {
      return
    }
    const container = scrollRef.current
    setHasOverflow(container.scrollWidth > container.clientWidth + container.scrollLeft)
  }, [])

  React.useEffect(() => {
    checkOverflow()
  }, [checkOverflow])

  return (
    <div className="relative">
      <div
        ref={scrollRef}
        className={tw('flex gap-2 overflow-x-auto no-scrollbar ', className)}
        onScroll={checkOverflow}
        data-testid={testid}
      >
        {children}
      </div>
      {hasOverflow ? (
        <button
          type="button"
          onClick={() => {
            scrollRef.current?.scrollTo({
              left: scrollRef.current?.scrollLeft + 200,
              behavior: 'smooth',
            })
          }}
          className="absolute right-0 top-1/2 -translate-y-1/2 flex items-center justify-center size-8 bg-cf-grey-100 rounded-full shadow-sm"
        >
          <IconChevronRight className="size-5 text-cf-grey-800" />
        </button>
      ) : null}
    </div>
  )
}
